module.exports = __webpack_public_path__ + "static/media/educator.5aee0e61.webp";